import { request } from '../../utils/axios';

const publicPrefix = '/public';

// ==================== 培训相关接口 ====================
export const getTraining = async (params) => {
  return request.get(`${publicPrefix}/training/list`, { params });
};
export const getTrainingDetail = async (params) => {
  return request.get(`${publicPrefix}/training/detail`, { params });
};

export const getHotCourse = async (params) => {
  return request.get(`${publicPrefix}/training/course/hotCourses`, { params });
};
export const getCourseList = async (params) => {
  return request.get(`${publicPrefix}/training/course/list`, { params });
};
export const getCourseDetail = async (params) => {
  return request.get(`${publicPrefix}/training/course/fullDetail`, { params });
};
export const enrollCourse = async (data) => {
  return request.post(`${publicPrefix}/training/course/addEnrollment`, data);
};
export const cancelEnrollCourse = async (data) => {
  return request.put(`${publicPrefix}/training/course/cancelEnrollmentByUser`, data);
};
export const getEnrolledCourseList = async (params) => {
  return request.get(`${publicPrefix}/training/course/enrolledCourses`, { params });
};
export const likeCourse = async (data) => {
  return request.post(`${publicPrefix}/training/course/like`, data);
};
export const courseComment = async (data) => {
  return request.post(`${publicPrefix}/training/course/addComment`, data);
};
export const courseCommentList = async (params) => {
  return request.get(`${publicPrefix}/training/course/commentList`, { params });
};

// ==================== 咨询相关 ====================
export const submitConsultation = async (data) => {
  return request.post(`${publicPrefix}/consultation/submit`, data);
};
export const getUserConsultationList = async (params) => {
  return request.get(`${publicPrefix}/consultation/listByUser`, { params });
};
export const getExpertConsultationList = async (params) => {
  return request.get(`${publicPrefix}/consultation/listByExpert`, { params });
};
export const getConsultationDetail = async (params) => {
  return request.get(`${publicPrefix}/consultation/queryById`, { params });
};
export const replyConsultation = async (data) => {
  return request.post(`${publicPrefix}/consultation/answerByBody`, data);
};

// 点赞/取消点赞专家
export const expertLike = async (formData) => {
  return request.post(`${publicPrefix}/expert/like`, formData);
};
export const expertUnLike = async (formData) => {
  return request.post(`${publicPrefix}/expert/unlike`, formData);
};
